<script setup lang="ts">
const props = defineProps({
	title: {
		type: String,
		require: true,
	},
	icon: {
		type: String,
		required: true,
	},
	/**
	 * Shows a close button on the right. Opt-in, so the drawers that were
	 * already closing themselves from a footer button or the scrim keep the
	 * header they had.
	 */
	closable: {
		type: Boolean,
		default: false,
	},
});

// Emitted rather than closing the drawer here: what "close" means is the
// caller's business — some contents have unsaved state to deal with first.
defineEmits<{ close: [] }>();
</script>

<template>
	<div
		style="background-color: rgb(var(--color-background))"
		class="pa-3 d-flex align-center"
	>
		<v-avatar color="secondary" class="mr-3">
			<v-icon color="primary">{{ icon }}</v-icon>
		</v-avatar>
		<span class="font-weight-semibold" style="font-size: 1.125rem">{{
			title
		}}</span>

		<template v-if="closable">
			<v-spacer />
			<v-btn
				icon="fa: fa-regular fa-xmark"
				size="small"
				variant="text"
				aria-label="Close"
				@click="$emit('close')"
			/>
		</template>
	</div>
	<v-divider style="border-color: #2a3547 !important"></v-divider>
</template>
